<template>
  <div>
  <UiContentwrapper>
    <UiNarrowcolumn v-if="mounted">
      <header class="mb-5 w-full flex justify-between">
        <!-- Rubriken visar titeln från den aktiva slidens artikel -->
        
        <h2 class="mb-2 lg:m-0">
          {{ slideHeader}}
        </h2>
        
      </header>
      <Carousel :items-to-show="1" :items-to-scroll="1" wrap-around ref="myCarousel">
        <Slide v-for="(article, index) in techBlog.articles" :key="article.id">
          <div class="slide-content relative">
                <UiArticleImage
                  v-if="article.image"
                  :article="article"
                  :modifiers="{
                    auto: 'format,compress',
                    crop: 'faces,edges',
                    ar: '914:475'
                  }"
                  :width="Number(914)"
                  :height="Number(475)"
                  sizes="341px sm:605px md:785px lg:914px"
                />
                
              </div>
        </Slide>
        

        <!-- Optionala addons: Navigation och Pagination -->
        <template #addons>
          <div class="paginationwrapper hidden md:inline lg:flex; md:absolute -translate-y-full right-2">
            <Pagination />
          </div>              
          <div class="flex flex-col lg:flex-row justify-between lg:items-start">
            <p class="w-full large lg:w-9/12 mt-3 lg:mt-8 mb-0 min-h-20">
                  {{ slideContent }}
            </p>
            <div class="lg:mt-8 flex gap-6 justify-end ">
              <Navigation>
                <!-- Replace the default "previous" icon -->
                  
                  <template #prev>
                    <Arrow/>
                  </template>
                  <template #next>
                    <Arrow class="rotate-180" />
                  </template>
                
              </Navigation>
            </div>
          </div>
              
          </template>
      </Carousel>
    </UiNarrowcolumn>
    
  </UiContentwrapper>
</div>
</template>

<script setup>
import { ref } from 'vue';
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();
const mounted = ref(false);
const myCarousel = ref(null);
var techBlog = ref(null);

// Definiera props
const props = defineProps({
  slug: {
    type: String,
    default: 'tech-slides'
  }
});

onMounted(async () => { 
  
  try{
    techBlog.value = await blogStore.fetchBlogByHandle(props.slug);
    mounted.value = true;
  }
  catch (err) {
    console.error('Error fetching slides data:', err);
  }

  
});


const slideHeader = computed(() => {
  try{
    //return techBlog.value.articles[0].title;
    return techBlog.value.articles[myCarousel.value.data.currentSlide].title;
  }catch (error) {
    return techBlog.value.articles[0].title;
    
  }
});

const slideContent = computed(() => {
  try{
    //return techBlog.value.articles[0].title; ADD ... if texts get longer than 120, now everything fits.
      let content = techBlog.value.articles[myCarousel.value.data.currentSlide].content;
      return content.length > 115 ? content.substring(0, 120) + '' : content;
    
  }catch (error) {
    return techBlog.value.articles[0].content;
    
  }
});


</script>

<style scoped>


.carousel :deep(.carousel__slide) {
  display: block;
}

.carousel :deep(.carousel__next) {
  position: relative;
  transform: none;
  display: block;
  height: 42px;
}

.carousel :deep(.carousel__prev) {
  position: relative;
  transform: none;
  display: block;
  height: 42px;
}

.carousel :deep(.carousel__pagination-item){
  padding: 5px 3px 10px;
}

.carousel :deep(.carousel__pagination-button){
  width: 47px;
  height: 6px;
}

.carousel {
  
  --vc-pgn-width: 25px;
  --vc-pgn-active-color: #E0DBCA;
  --vc-pgn-background-color: #ffffff66;
  
  
}

.carousel__pagination {
  
  bottom: inherit;
  left: inherit;
  position: relative !important;  
  display: flex;
  transform: none;
  
}




</style>